var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90365 10.3787L14.7209 1.56139L15.0721 1.92096L5.5501 11.443L0.92807 6.82096L1.27928 6.46139L5.19654 10.3787L5.5501 10.7322L5.90365 10.3787Z",
    fill: "#EBEBEB",
    stroke: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconDark);
export default __webpack_public_path__ + "static/media/CheckIconDark.37435669b0cbab6fda1a08632b6c11ab.svg";
export { ForwardRef as ReactComponent };